export default {
  'authenticatedPage.redirectMessageHeader': 'You are being redirected to:',
  'authenticatedPage.noPermissions':
    'You do not currently have permissions to view any application.',
};
